import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  className = '',
  href,
  target,
  rel,
}) => {
  const baseStyle = "inline-block font-medium tracking-wider text-sm py-4 px-8 transition-all duration-300 uppercase border focus:outline-none";
  
  const variantStyles = {
    primary: "text-white border-white hover:bg-white hover:text-black",
    secondary: "text-white border-red-600 bg-red-600 hover:bg-red-700",
  };
  
  const buttonStyle = `${baseStyle} ${variantStyles[variant]} ${className}`;
  
  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={buttonStyle}>
        {children}
      </a>
    );
  }

  return (
    <button 
      className={buttonStyle}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;